export const clientInitialState = {
  anonymityInfo: null,
  isLoading: false,
};
